import { DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import Button from 'src/components/Button';
import CustomInput from 'src/components/CustomInput';
import { ErrorMessage } from 'src/components/ErrorMessage';
import { Popup } from 'src/components/Popup';
import useStyles from './useStyles';

export const PopupWithInputField = ({
  classes,
  title,
  subtitle,
  onSubmit,
  onCancel,
  cancelText,
  submitText,
  error,
  value,
  placeholder,
  onChange,
  loading,
  disabled,
  ...restProps
}) => {
  const styles = useStyles({ classes });

  const handleFormSubmit = (event) => {
    event.preventDefault();
    onSubmit(event);
  };

  const handleOnInputFocus = useCallback((event) => {
    event.target.select();
  }, []);

  return (
    <Popup
      classes={{
        paper: styles.root,
        closeButton: styles.buttonClose,
      }}
      onClose={onCancel}
      {...restProps}
    >
      <DialogTitle
        className={styles.dialogTitle}
        disableTypography
      >
        <Typography
          className={styles.title}
          variant="h4"
        >
          {title}
        </Typography>
      </DialogTitle>

      <form onSubmit={handleFormSubmit}>
        <DialogContent
          className={cx(styles.dialogContent, { [styles.dialogContentWithSubtitle]: !!subtitle })}
        >
          {subtitle && (
            <Typography
              className={styles.subtitle}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
          <CustomInput
            className={styles.field}
            value={value}
            onChange={onChange}
            error={error}
            placeholder={placeholder}
            autoFocus
            disabled={disabled || loading}
            onFocus={handleOnInputFocus}
          />
          <ErrorMessage error={error} />
        </DialogContent>

        <DialogActions className={styles.dialogActions}>
          {cancelText && (
            <Button
              className={styles.buttonCancel}
              onClick={onCancel}
              disabled={disabled}
              variant="text"
              color="primary"
            >
              {cancelText}
            </Button>
          )}
          <Button
            className={styles.buttonSubmit}
            loading={loading}
            disabled={disabled}
            type="submit"
            variant="contained"
            color="primary"
          >
            {submitText}
          </Button>
        </DialogActions>
      </form>
    </Popup>
  );
};

PopupWithInputField.propTypes = {
  classes: PropTypes.shape({}),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  submitText: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

PopupWithInputField.defaultProps = {
  classes: null,
  title: null,
  subtitle: null,
  cancelText: null,
  placeholder: null,
  value: '',
  error: null,
  loading: false,
  disabled: false,
};
